import { render, staticRenderFns } from "./piccenter.vue?vue&type=template&id=0557521c&scoped=true&"
import script from "./piccenter.vue?vue&type=script&lang=js&"
export * from "./piccenter.vue?vue&type=script&lang=js&"
import style0 from "./piccenter.vue?vue&type=style&index=0&id=0557521c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0557521c",
  null
  
)

export default component.exports